import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BoxIcon, FileTextIcon, LockIcon, UserIcon } from 'lucide-react';
import { Button } from '../ui/Button';
import { Seal } from '../brand/Seal';
const marks = [{
  icon: UserIcon,
  label: 'Licensed clinicians',
  detail: 'In all 50 states'
}, {
  icon: LockIcon,
  label: 'Secure & private',
  detail: 'HIPAA-compliant'
}, {
  icon: FileTextIcon,
  label: 'Transparent pricing',
  detail: 'Published up front'
}, {
  icon: BoxIcon,
  label: 'Discreet delivery',
  detail: 'Unbranded, cold-chain'
}];
export function Hero() {
  return <section className="bg-cream" data-id="element-45" data-mp="r5gesfyui3n">
      <div className="mx-auto max-w-shell px-6 pb-10 pt-12 md:px-8 md:pb-14 md:pt-20" data-id="element-46" data-mp="s753zpwn33u">
        <div className="grid items-end gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16" data-id="element-47" data-mp="3ryi29krsnjpw">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-48" data-mp="1v3ve7l9ggbgb">
            <h1 className="font-serif text-[3.25rem] leading-[0.98] text-ink sm:text-7xl lg:text-[5.75rem]" data-id="element-49" data-mp="1murgejj31w1c">
              Healthcare belongs
              <br data-id="element-50" data-mp="1cy6c60ew0oyk" />
              to everyone.
            </h1>
            <p className="mt-8 max-w-lg text-lg leading-relaxed text-ink-soft" data-id="element-51" data-mp="1czpurxo0nc3i">
              Clinically directed care and medications delivered with exceptional quality,
              convenience, transparency and pricing.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-52" data-mp="2alx4flz6fumq">
              <Button to="/get-started" data-id="element-53" data-mp="2anzv8885lrsi">
                Start your intake
                <ArrowRightIcon className="h-4 w-4" data-id="element-54" data-mp="1vw92qjn32tyh" />
              </Button>
              <Link to="/programs" className="group inline-flex items-center gap-2 text-sm text-ink transition-colors duration-150 ease-republic hover:text-brick" data-id="element-55" data-mp="20vbytel35pub">
                See what Republic can do for you
                <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-republic group-hover:translate-x-1" data-id="element-56" data-mp="2te9aojsybg25" />
              </Link>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.55,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative" data-id="element-57" data-mp="2y77ht5nygynk">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/26deb3e1-2c41-40d4-93bf-5fd27d7f7b3e.jpg" alt="A Republic patient photographed against a warm grey studio backdrop" className="aspect-[4/5] w-full object-cover" data-id="element-58" data-mp="2k9sp9s2eoard" />
            <Seal className="absolute -left-6 -top-6 hidden h-24 w-24 text-ink/70 lg:block" data-id="element-59" data-mp="26ixda6wm1djk" />
          </motion.div>
        </div>

        <div className="rule mt-14 pt-8" data-id="element-60" data-mp="21ii31o7mkm5t">
          <ul className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:divide-x lg:divide-ink/10" data-id="element-61" data-mp="1wjycfai36m74">
            {marks.map(mark => <li key={mark.label} className="flex items-start gap-4 lg:px-6 lg:first:pl-0" data-id="element-62" data-mp="c0umigxmu6na">
                <mark.icon className="mt-0.5 h-5 w-5 shrink-0 text-ink" strokeWidth={1.4} data-id="element-63" data-mp="h07jhui7wu3l" />
                <div data-id="element-64" data-mp="lztx451ykccx">
                  <p className="text-sm font-medium text-ink" data-id="element-65" data-mp="m1eqhrcjdp97">{mark.label}</p>
                  <p className="mt-1 text-sm text-ink-muted" data-id="element-66" data-mp="q1yo0w10uuvv">{mark.detail}</p>
                </div>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}